import { useLanguage } from "@/i18n/LanguageContext";
import { useHomeFaqs } from "@/hooks/useCatalog";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";



export default function HomeFAQ() {
  const { t } = useLanguage();
  const { items } = useHomeFaqs();
  if (!items.length) return null;
  return (
    <section className="py-16 md:py-20 border-t border-border">
      <div className="container mx-auto px-4 max-w-3xl">
        <p className="eyebrow mb-3">{t("FAQ")}</p>
        <h2 className="text-3xl md:text-4xl font-bold mb-8">{t("Straight answers about BEEDIGIT.")}</h2>
        <Accordion type="single" collapsible className="border border-border rounded-lg divide-y divide-border bg-card">
          {items.map((i, idx) => (
            <AccordionItem key={i.q} value={`item-${idx}`} className="border-0">
              <AccordionTrigger className="px-5 text-left">{t(i.q)}</AccordionTrigger>
              <AccordionContent className="px-5 text-muted-foreground">{t(i.a)}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}

export { HOME_FAQS as HOME_FAQ_ITEMS } from "@/content/faqs";